<template>
  <div class="main-layout">
    <div class="layout-title">
      <u-title-page :title="NameComponent" />
    </div>
    <div class="layout-content">
      <u-table
        :headers="headers"
        :items="items"
        :mobileBreakpoint="900"
        :showSelect="false"
        itemKey="package_id"
        :pagination="pagination"
        @onChangePagination="onChangePagination"
        :loading="loading"
      >
        <template v-slot:header>
          <v-row
            justify="space-between"
            align="center"
            class="header-custom-table"
          >
            <!-- // # Action Group -->
            <v-col cols="12" md="4">
              <v-row justify="start" align="center">
                <v-col cols="12" md="6">
                  <v-btn color="primary" block dark @click="dialog = !dialog">
                    <v-icon>mdi-home-plus</v-icon>เพิ่ม{{ NameComponent }}
                  </v-btn></v-col
                >
              </v-row>
            </v-col>
            <!-- // # Search Group -->
            <v-col cols="12" md="4">
              <v-row justify="center" align="center">
                <v-col
                  ><v-text-field
                    v-model="keyword"
                    name="name"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    placeholder="ค้นหา"
                    label="ค้นหา"
                    hide-details
                    @keyup.enter="init()"
                  ></v-text-field
                ></v-col>
                <v-col cols="4">
                  <v-btn color="primary" block dark @click="init()"
                    >ค้นหา</v-btn
                  ></v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.number`]="{ item }">
              {{
                pagination.row * pagination.page -
                pagination.row +
                (items.indexOf(item) + 1)
              }}
            </template>

        <template v-slot:[`item.limit`]="{ item }">
          {{ item.limit === 0 ? "ไม่จำกัด" : item.limit }}
        </template>

        <template v-slot:[`item.services`]="{ item }">
          <span v-if="item.services.length == 0">-</span>
          <span v-else>
            <v-chip
              outlined
              small
              v-for="t in item.services"
              :key="t.service_id"
              color="primary"
              class="my-1"
            >
              {{ t.name }}
            </v-chip>
          </span>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{
              item.description !== "" && item.description !== null
                ? item.description
                : "-"
            }}
          </span>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{ item.name }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="primary"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>แก้ไขข้อมูล</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="error"
                @click="deleteItem(item)"
              >
                <v-icon>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <span>ลบ</span>
          </v-tooltip>
        </template>
      </u-table>
    </div>

    <!-- // # Form Add/Edit -->
    <u-card-form
      v-model="dialog"
      :title="formTitle"
      :subtitle="formSubTitle"
      ref="form"
    >
      <template v-slot:form>
        <div>
          <span class="required">*</span><span>ชื่อ{{ NameComponent }}</span>
        </div>
        <v-text-field
          v-model="editedItem.name"
          :rules="[Rule.noInPut]"
          required
          outlined
          dense
          :placeholder="`กรุณากรอกชื่อ${NameComponent}`"
        ></v-text-field>

        <div><span class="required">*</span><span>จำนวนไฟล์</span></div>
        <v-checkbox
          v-model="unlimit"
          class="mb-n3 mt-0"
          label="ไม่จำกัด"
        ></v-checkbox>
        <v-text-field
          v-if="unlimit"
          value="ไม่จำกัด"
          disabled
          outlined
          dense
          :placeholder="`จำนวนฟิล์ม`"
        ></v-text-field>
        <v-text-field
          v-if="!unlimit"
          v-model="editedItem.limit"
          :rules="[Rule.noInPut, Rule.numberOnly, Rule.countingNumberOnly]"
          outlined
          dense
          maxlength="4"
          suffix="ไฟล์/เดือน"
          placeholder="กรุณากรอกจำนวนไฟล์/เดือน"
        ></v-text-field>

        <div><span class="required">*</span><span>ราคา</span></div>
        <v-text-field
          v-model="editedItem.price"
          :rules="[Rule.noInPut, Rule.numberOnly, Rule.countingNumberOnly]"
          outlined
          dense
          maxlength="4"
          suffix="บาท/เดือน"
          placeholder="กรุณากรอกราคา/เดือน"
        ></v-text-field>

        <div>
          <div><span class="required">*</span><span>บริการ</span></div>
          <v-select
            v-model="editedItem.services"
            :items="services"
            :rules="[Rule.noArray]"
            placeholder="กรุณาเลือกบริการ"
            item-value="service_id"
            item-text="name"
            :disabled="loading"
            :loading="loading"
            required
            outlined
            dense
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index <= 1">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text text-caption">
                (+{{ editedItem.services.length - 2 }} others)
              </span>
            </template>
          </v-select>
        </div>

        <div><span>บันทึกรายละเอียด</span></div>
        <v-textarea
          v-model="editedItem.description"
          outlined
          placeholder="รายละเอียด"
          value=""
        ></v-textarea>
      </template>
      <template v-slot:actions="{ valid }">
        <v-row>
          <v-col>
            <v-btn
              :disabled="!valid"
              @click="save"
              block
              color="primary"
              :loading="loadingSave"
            >
              บันทึก
            </v-btn>
          </v-col>
          <v-col
            ><v-btn block color="error" @click="close">ยกเลิก</v-btn></v-col
          >
        </v-row>
      </template>
    </u-card-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      unlimit: false,
      loading: false,
      loadingSave: false,
      NameComponent: 'แพ็คเกจ',
      dialog: false, // สำหรับใช้เปิดปิด dialog add/edit
      IdEdit: '',
      editedIndex: -1,
      editedItem: {
        package_id: '',
        name: '',
        limit: '',
        price: '',
        services: [],
        description: ''
      },
      defaultItem: {
        package_id: '',
        name: '',
        limit: '',
        price: '',
        services: [],
        description: ''
      },
      pagination: {
        total: 0,
        page: 1,
        row: 10
      },
      keyword: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'number'
        },
        {
          text: 'ชื่อแพ็คเกจ',
          align: 'start',
          value: 'name',
          sortable: false,
          width: '20%'
        },
        {
          text: 'ไฟล์/เดือน',
          value: 'limit',
          align: 'center',
          sortable: false
        },
        {
          text: 'ราคา/เดือน',
          value: 'price',
          align: 'center',
          sortable: false
        },
        {
          text: 'บริการ',
          value: 'services',
          align: 'center',
          sortable: false,
          width: '50%'
        },
        {
          text: 'รายละเอียด',
          value: 'description',
          align: 'start',
          sortable: false
        },
        {
          text: 'จัดการ',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '15%'
        }
      ],
      items: [],
      services: []
    }
  },
  watch: {
    dialog (n) {
      if (n) this.initService()
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? `เพิ่ม${this.NameComponent}`
        : `แก้ไข${this.NameComponent}`
    },
    formSubTitle () {
      return this.editedIndex === -1
        ? `กรอกข้อมูลเพื่อสร้าง${this.NameComponent}`
        : `กรอกข้อมูลเพื่อแก้ไข${this.NameComponent}`
    }
  },
  created () {
    this.init()
    this.initService()
  },
  methods: {
    async init () {
      this.loading = true
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        page: this.pagination.page,
        row: this.pagination.row,
        keyword: this.keyword
      }
      const res = await this.getPackageForTable(payload)
      this.loading = false
      if (res.status) {
        this.items = res.data.data
        this.pagination = res.data.pagination
      } else {
        this.antmessage.error(res.message)
      }
    },

    async initService () {
      this.loading = true
      const res = await this.getServiceForDropdown()
      this.loading = false
      if (res.status) {
        this.services = res.data
      } else {
        this.antmessage.error(res.message)
      }
    },
    onChangePagination (val) {
      this.pagination.page = val.page
      this.pagination.row = val.row
      this.init()
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      const listService = []

      for (let index = 0; index < this.editedItem.services.length; index++) {
        listService.push(this.editedItem.services[index].service_id)
      }
      this.editedItem.services = listService
      if (this.editedItem.limit === 0) {
        this.unlimit = true
        this.editedItem.limit = ''
      }
      this.editedItem.price = this.editedItem.price.toString()
      this.dialog = true
    },

    deleteItem (item) {
      this.$swal({
        allowEnterKey: false,
        title: `ลบ${this.NameComponent}`,
        text: `คุณต้องการลบ${this.NameComponent}นี้ใช่หรือไม่`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.antmessage.loading('กำลังดำเนินการ', 0)
          const payload = { package_id: item.package_id }
          const res = await this.deleteItemPackage(payload)
          this.antmessage.destroy()
          if (res.status) {
            this.init()
            this.$swal({
              allowEnterKey: false,
              title: 'สำเร็จ',
              text: `ลบ${this.NameComponent}สำเร็จ`,
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: false,
              timer: 3000
            })
          } else {
            this.antmessage.error(res.message)
          }
        }
      })
    },
    close () {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        if (this.unlimit) {
          this.editedItem.limit = 0
        }
        // TODO Update Data
        this.$swal({
          allowEnterKey: false,
          title: `แก้ไข${this.NameComponent}`,
          text: `คุณต้องการแก้ไข${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true
            const payload = {
              package_id: this.editedItem.package_id,
              name: this.editedItem.name,
              limit: parseInt(this.editedItem.limit),
              services: this.editedItem.services,
              price: parseInt(this.editedItem.price),
              description: this.editedItem.description
            }
            const res = await this.updatePackage(payload)
            this.loadingSave = false
            if (res.status) {
              this.init()
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `แก้ไข${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        })
      } else {
        // TODO Create Data
        this.$swal({
          allowEnterKey: false,
          title: `เพิ่ม${this.NameComponent}`,
          text: `คุณต้องการเพิ่ม${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true
            const payload = {
              ...this.editedItem,
              ...{
                limit: parseInt(this.editedItem.limit),
                price: parseInt(this.editedItem.price)
              }
            }
            const res = await this.createPackage(payload)
            this.loadingSave = false
            if (res.status) {
              this.init()
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `เพิ่ม${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
/* สำหรับจัดการหน้าเพจทั้งหมด */
.main-layout {
  height: 100%;
}

/* สำหรับ จัดการ title ของเพจ */
.layout-title {
  height: 58px;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

/* สำหรับจัดการ Content ของเพจ */
.layout-content {
  height: calc(100% - 58px);
  padding: 0;
  margin: 0;
}

.header-custom-table .header-custom-search {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}

.header-custom-table .header-custom-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  height: 100%;
  min-height: 70px;
}
</style>
